import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/telephony_accounts/telephony_account.vue'

export default class extends Controller {
  static values = {
    telephonyAccount: Object
  }

  connect() {
    const props = {
      telephonyAccount: this.telephonyAccountValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
